import React from "react";
import TextField from "./Fields/TextField";
import FileField from "./Fields/FileField";
import SelectField from "./Fields/SelectField";
import SwitchField from "./Fields/SwitchField";
import TextAreaField from "./Fields/TextAreaField";

const FieldContainer = ({
  type,
  name,
  id,
  options,
  label,
  fileRef,
  ...rest
}) => {
  switch (type) {
    case "text":
    case "email":
    case "password":
    case "radio":
      return (
        <TextField type={type} name={name} id={id} label={label} {...rest} />
      );
    case "file":
      return (
        <FileField ref={fileRef} type={type} name={name} id={id} {...rest} />
      );
    case "select":
      return (
        <SelectField
          type={type}
          name={name}
          id={id}
          label={label}
          options={options}
          {...rest}
        />
      );
    case "switch":
      return <SwitchField name={name} id={id} label={label} {...rest} />;
    case "textarea":
      return <TextAreaField name={name} id={id} label={label} {...rest} />;
    default:
      return (
        <TextField type={"text"} name={name} id={id} label={label} {...rest} />
      );
  }
};

export default FieldContainer;
